import React, { useEffect } from "react";
import CSS from 'csstype';
import { v4 as uuidv4 } from 'uuid';

const OrderSvg: React.FC<{ style: React.CSSProperties, opacity:string}> = ({ style, opacity }) => {




  return (
    <svg

      style={style}

      

      xmlns="http://www.w3.org/2000/svg"

      preserveAspectRatio="none"
      version="1.1"
      viewBox="0 0 18.145 22"
    >
      <defs>


        <pattern id="diagonalHatch2" width=".5" height=".5" patternTransform="rotate(60 0 0)" patternUnits="userSpaceOnUse">
          <line x1="0" y1="0" x2="0" y2=".5" stroke="#487970" strokeWidth=".1"/>
        </pattern>

        <filter id="dropshadow" height="130%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="3" />
          <feOffset dx=".5" dy=".5" result="offsetblur" />
          <feComponentTransfer>
            <feFuncA type="linear" slope="0.2" />
          </feComponentTransfer>
          <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>





      </defs>
      <g
        fill="#fff"
        fillOpacity="1"
        stroke="#fff"
        strokeDasharray="none"
        strokeMiterlimit="4"
        strokeOpacity="0"
        strokeWidth="1"
        opacity="1"
      >
        <path
          filter="url(#dropshadow)"
          fill="#fff"

          fillOpacity="1"
          stroke="#000"

          strokeDasharray="none"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit="4"
          strokeOpacity="0"
          strokeWidth=".1"

          d={`
          M 18.145 , 0
          v 22
          H 0
          v -1
          l 18.145 , -21
          `}
        ></path>




      </g>
    </svg>
  );
}

export default OrderSvg;
